import styled from 'styled-components';

import { ActionButton } from 'components/action-button';

export const StyledSignupButton = styled(ActionButton)`
  padding-inline: 0.725rem;
`;

export const SignupButtonWrapper = styled.div`
  min-width: 0;
`;
